import { axiosGet, handleOnError } from '../utils/api';

class StatisticsService {
    async fetch(params={}){
        try{
            let response = await axiosGet('statistics/fetch',params);
            return response.data
          }catch(error){
              return await handleOnError(error);
        }
    }
}

export default new StatisticsService();